import { RgbaColor, colord } from 'colord';
import { styled } from 'styled-components';
import { extractUniqueColorsFromJSON } from '../../../../functions/utils/extractUniqueColorsFromJSON';
import { useScene } from '../../../../hooks';

export const ColorSwatches = ({
  handleColorClick,
}: {
  handleColorClick: (newColor: RgbaColor) => void;
}) => {
  const scene = useScene();
  const presetColors = extractUniqueColorsFromJSON(
    scene.exportLauncherConfigJSON()
  );
  const backgroundColors = presetColors.backgroundColor.sort();
  const fontColors = presetColors.color.sort();
  const borderColors = presetColors.borderColor.sort();
  return (
    <Container>
      <Label>Background colors</Label>
      <Swatches>
        {backgroundColors.map((presetColor, i) => (
          <ColorPreview key={`backgroundColors-swatch-${i}`}>
            <Checkboard />
            <ColorFill
              $color={presetColor}
              onClick={() =>
                handleColorClick(colord(presetColor).toRgb() as RgbaColor)
              }
            />
          </ColorPreview>
        ))}
      </Swatches>

      <Label>Font colors</Label>
      <Swatches>
        {fontColors.map((presetColor, i) => (
          <ColorPreview key={`fontColors-swatch-${i}`}>
            <Checkboard />
            <ColorFill
              $color={presetColor}
              onClick={() =>
                handleColorClick(colord(presetColor).toRgb() as RgbaColor)
              }
            />
          </ColorPreview>
        ))}
      </Swatches>

      <Label>Border colors</Label>
      <Swatches>
        {borderColors.map((presetColor, i) => (
          <ColorPreview key={`borderColors-swatch-${i}`}>
            <Checkboard />
            <ColorFill
              $color={presetColor}
              onClick={() =>
                handleColorClick(colord(presetColor).toRgb() as RgbaColor)
              }
            />
          </ColorPreview>
        ))}
      </Swatches>
    </Container>
  );
};

const Container = styled.div`
  user-select: none;

  label {
    padding-left: 3px;
    padding-right: 8px;
  }

  color: var(--text-color);
  font-family: 'Inter';
  font-size: 12px;
`;

const Label = styled.span`
  display: block;
  padding: 0 10px;
  color: var(--text-color-secondary);
`;

const Swatches = styled.div`
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

const ColorPreview = styled.div`
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  width: 25px;
  height: 25px;
  border-radius: 5px;

  overflow: hidden;

  transition: transform 0.2s ease;
  &:hover {
    transform: scale(1.2);
  }
`;

const Checkboard = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  background: url('data:image/svg+xml;utf8,<svg preserveAspectRatio="none"  viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><rect x="0" y="0" width="5" height="5" fill="grey" /><rect x="5" y="5" width="5" height="5" fill="grey" /><rect x="5" y="0" width="5" height="5" fill="white" /><rect x="0" y="5" width="5" height="5" fill="white" /></svg>')
    0 0/15px 15px round;
`;

const ColorFill = styled.div<{ $color?: string }>`
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  ${({ $color }) => $color && `background-color: ${$color};`}
`;
